import CashierServiceCollection from "../CashierServiceCollection";
import StockKeepingUnitModel from "../../models/cashier/StockKeepingUnitModel";

export default class StockKeepingUnitCollection extends CashierServiceCollection {

  model() {
    return StockKeepingUnitModel;
  }

  publicRoutes() {
    let model = (new (this.model())());
    return {
      fetch: process.env.VUE_APP_CASHIER_REPOSITORY_URL + '/api/v1/public/' + model.modelName(),
    }
  }

}
